import { _generateCiiAveragePlotLine } from "./cii_average_chart_options";

function _generateFoulingAverageChartOptions(voyageDataForCiiHistory, foulingData) {
  const chartOptions = {
    chart: {
      zoomType: "x",
      panning: true,
      panKey: "shift"
    },
    resetZoomButton: {
      position: {
        align: "right",
        verticalAlign: "top",
        x: -10,
        y: 10
      },
      theme: {
        fill: "var(--color-text)",
        stroke: "silver",
        r: 0,
        states: {
          hover: {
            fill: "var(--color-text)",
            style: {
              color: "white"
            }
          }
        }
      }
    },
    credits: {
      enabled: false,
    },
    time: {
      useUTC: true,
    },
    title: {
      text: null,
    },
    yAxis: {
      max:null,
      min:null,
      gridLineWidth: 2,
      title: {
        text: "Power [%]​",
        align: "high",
        style: {
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    xAxis: {
      type: "datetime",

      title: {
        align: "high",
        style: {
          fontSize: "14px",
        },
      },
      labels: {
        format: "{value:%m-%Y}",
        style: {
          fontSize: "12px",
        },
      },
      crosshair: true,
      plotLines: voyageDataForCiiHistory
        ? voyageDataForCiiHistory.map((voyageData) => _generateCiiAveragePlotLine(voyageData)) : [],
    },
    exporting: {
      enabled: false,
    },
    legend: {
      layout: "horizontal",
      align: "right",
      verticalAlign: "top",
      //floating: true
    },
    series: [_generateFoulingAverageSeries(foulingData.polynomials, voyageDataForCiiHistory)],
  };
  return chartOptions;
}

function _averageFoulingBetweenDates(series, startDate, endDate) {
  const startDateTimestamp = new Date(startDate).getTime();
  const endDateTimestamp = new Date(endDate).getTime();
  const foulingValues = series.filter((datum) => {
    return datum.dateTimeStamp >= startDateTimestamp && datum.dateTimeStamp <= endDateTimestamp;
  });
  const averageFouling = foulingValues.reduce((sum, datum) => sum + datum.predsLinear, 0) / foulingValues.length;
  return averageFouling;
}

function _generateFoulingAverageSeriesData(series, voyageData) {
  const seriesData = [];
  if (voyageData) {
    for (const voyage of voyageData) {
      const averageFouling = _averageFoulingBetweenDates(
        series,
        voyage.startDate,
        voyage.endDate
      );
      seriesData.push([voyage.startDateTimestamp, averageFouling]);
      seriesData.push([voyage.endDateTimestamp, averageFouling]);
    }
  }
  return seriesData;
}

function _generateFoulingAverageSeries(series, voyageData) {
  return {
    name: "Average Fouling",
    type: "line",

    color: "#3EABB0",
    data: _generateFoulingAverageSeriesData(series, voyageData),
    visible: true,
    marker: {
      enabled: false,
    },
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
  };
}

export { _generateFoulingAverageChartOptions, _generateFoulingAverageSeries };
